/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartVennIntersectDown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M9 7a5 5 0 1 0 0 10 1 1 0 1 1 0 2A7 7 0 1 1 9 5a1 1 0 0 1 0 2zm5-1a1 1 0 0 1 1-1 7 7 0 0 1 7 7 1 1 0 1 1-2 0 5 5 0 0 0-5-5 1 1 0 0 1-1-1zm-2 1.263C10.752 8.378 10 10.13 10 12s.752 3.622 2 4.737c1.248-1.115 2-2.868 2-4.737s-.752-3.622-2-4.737zM18 15v3.586l-1.293-1.293-1.414 1.414 3 3 .707.707.707-.707 3-3-1.414-1.414L20 18.586V15z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgChartVennIntersectDown as ChartVennIntersectDown };
